import { jsx } from 'react/jsx-runtime';
import Skeleton from 'react-loading-skeleton';
import 'classnames';
import '../Table/components/HeaderCell.module.scss.js';
import '../layout/Flex/Flex.js';
import '../layout/Row/Row.module.scss.js';
import '../layout/Stack/Stack.js';
import '../layout/Box/Box.js';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import '../Table/Table.module.scss.js';
import 'react';
import '../Table/components/TableRow.module.scss.js';
import '../Table/components/Pagination.module.scss.js';
import '../Text/Text.js';
import '../Table/components/TableCell/TableCell.module.scss.js';
import Card from '../Card/Card.js';
import '../List/List.module.scss.js';
import '../ErrorBox/ErrorBox.module.scss.js';
import '../InfoBox/InfoBox.module.scss.js';
import '../KpiCard/KpiCard.module.scss.js';
import '../TrendValue/TrendValue.module.scss.js';
import '../Modal/Modal.module.scss.js';
import '../../client-components/ThemeProvider.js';
import '../../client-components/Tabs/Tabs.module.scss.js';
import '../../client-components/ThemeModeSelector/ThemeModeSelector.module.scss.js';
import '../../client-components/ExpandableCard/ExpandableCard.module.scss.js';
import '../../client-components/ExpandableKpiCard/ExpandableKpiCard.module.scss.js';
import '../../client-components/CopyButton/CopyButton.module.scss.js';
import 'ethereum-blockies-base64';
import 'luxon';
import '../../client-components/WalletAddress/WalletAddress.module.scss.js';
import '../../client-components/filters/TextSearchFilter/TextSearchFilter.module.scss.js';
import '@blockanalitica/ui';
import '../../client-components/sidebars/FixedSidebar/components/MobileTopNavBar/MobileTopNavbar.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/components/Sidebar/Sidebar.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/FixedSidebar.module.scss.js';
import '../../client-components/sidebars/CollapsableSidebar/CollapsableSidebar.module.scss.js';
import '../../client-components/FormattedCurrency/FormattedCurrency.js';
import '../../client-components/FormattedPercentage/FormattedPercentage.js';
import '../../client-components/CurrencyValue/CurrencyValue.module.scss.js';
import '../../client-components/PercentageValue/PercentageValue.module.scss.js';
import '../../client-components/DisplaySwitch/DisplaySwitch.module.scss.js';
import '../../client-components/Tooltip/Tooltip.js';
import 'lodash';
import '../../client-components/charts/ChartJS.js';
import '../../client-components/charts/components/ChartKpis/ChartKpis.module.scss.js';
import '../../client-components/charts/components/ChartSingleValueIndicator/ChartSingleValueIndicator.module.scss.js';
import '../../client-components/charts/BarChart/BarChart.module.scss.js';
import '../../client-components/charts/LineChart/LineChart.module.scss.js';
import '../../client-components/charts/AreaChart/AreaChart.module.scss.js';
import 'randomcolor';
import 'd3';
import '../../client-components/Checkbox/Checkbox.module.scss.js';
import '../Badge/Badge.module.scss.js';
import '../HeatmapActivity/HeatmapActivity.module.scss.js';
import '../Switch/Switch.module.scss.js';
import '../Select/Select.module.scss.js';
import '../pictograms/EthPictogram.js';
import '../pictograms/EtherScanPictogram.js';
import '../pictograms/DebankPictogram.js';
import '../pictograms/ZapperPictogram.js';
import '../pictograms/DaiPictogram.js';

function CardLoader({ headerHeight = '2.5rem', bodyHeight = '10rem' }) {
    return (jsx(Card, { header: {
            title: (jsx("div", { style: { width: '100%' }, children: jsx(Skeleton, { height: headerHeight }) }))
        }, borderless: true, flexBasis: "100%", children: jsx(Skeleton, { height: bodyHeight }) }));
}

export { CardLoader as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FyZExvYWRlci5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc2VydmVyLWNvbXBvbmVudHMvbG9hZGVycy9DYXJkTG9hZGVyLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgU2tlbGV0b24gZnJvbSAncmVhY3QtbG9hZGluZy1za2VsZXRvbic7XG5pbXBvcnQgeyBDYXJkIH0gZnJvbSAnLi4nO1xuXG50eXBlIENhcmRMb2FkZXJQcm9wcyA9IHtcbiAgaGVhZGVySGVpZ2h0Pzogc3RyaW5nIHwgbnVtYmVyO1xuICBib2R5SGVpZ2h0Pzogc3RyaW5nIHwgbnVtYmVyO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gQ2FyZExvYWRlcih7XG4gIGhlYWRlckhlaWdodCA9ICcyLjVyZW0nLFxuICBib2R5SGVpZ2h0ID0gJzEwcmVtJ1xufTogQ2FyZExvYWRlclByb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPENhcmRcbiAgICAgIGhlYWRlcj17e1xuICAgICAgICB0aXRsZTogKFxuICAgICAgICAgIDxkaXYgc3R5bGU9e3sgd2lkdGg6ICcxMDAlJyB9fT5cbiAgICAgICAgICAgIDxTa2VsZXRvbiBoZWlnaHQ9e2hlYWRlckhlaWdodH0gLz5cbiAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgKVxuICAgICAgfX1cbiAgICAgIGJvcmRlcmxlc3M9e3RydWV9XG4gICAgICBmbGV4QmFzaXM9XCIxMDAlXCI+XG4gICAgICA8U2tlbGV0b24gaGVpZ2h0PXtib2R5SGVpZ2h0fSAvPlxuICAgIDwvQ2FyZD5cbiAgKTtcbn1cbiJdLCJuYW1lcyI6WyJfanN4Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQVF3QixTQUFBLFVBQVUsQ0FBQyxFQUNqQyxZQUFZLEdBQUcsUUFBUSxFQUN2QixVQUFVLEdBQUcsT0FBTyxFQUNKLEVBQUE7QUFDaEIsSUFBQSxRQUNFQSxHQUFBLENBQUMsSUFBSSxFQUFBLEVBQ0gsTUFBTSxFQUFFO0FBQ04sWUFBQSxLQUFLLEdBQ0hBLEdBQUEsQ0FBQSxLQUFBLEVBQUEsRUFBSyxLQUFLLEVBQUUsRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLEVBQzNCLFFBQUEsRUFBQUEsR0FBQSxDQUFDLFFBQVEsRUFBQyxFQUFBLE1BQU0sRUFBRSxZQUFZLEVBQUEsQ0FBSSxHQUM5QixDQUNQO0FBQ0YsU0FBQSxFQUNELFVBQVUsRUFBRSxJQUFJLEVBQ2hCLFNBQVMsRUFBQyxNQUFNLEVBQUEsUUFBQSxFQUNoQkEsR0FBQyxDQUFBLFFBQVEsSUFBQyxNQUFNLEVBQUUsVUFBVSxFQUFJLENBQUEsRUFBQSxDQUMzQixFQUNQO0FBQ0o7Ozs7In0=
